module.exports = __webpack_public_path__ + "static/roof_night-7fbe74b63c2c00f73c7e62119505ed93.jpg";